export { default } from "./ScoreVideoSlide";
